import React, { useRef } from 'react';
import './NumberInput.scss';
import { useField } from 'formik';
import InfoIcon from '../../../assets/icons/ic-info.svg';
import {
  Tooltip,
  OverlayTrigger,
  FormGroup,
  FormLabel,
  Form,
} from 'react-bootstrap';

interface IProps {
  name: string;
  labelText: string;
  toolTipText: string;
  disabled?: boolean;
  required?: boolean;
  postfixText?: string;
  imageFile?: any;
  OriginalHeight?: number | null;
  ImageHeight?: number | null;
  OriginalWidth?: number | null;
  ImageWidth?: number | null;
  OriginalSize?: boolean;
  MaintainAspectRatio?: boolean;
}

const NumberInput = ({
  name,
  labelText,
  imageFile,
  toolTipText,
  disabled = false,
  required = false,
  postfixText,
  OriginalSize,
  OriginalWidth,
  OriginalHeight,
  ImageHeight,
  ImageWidth,
  MaintainAspectRatio,
}: IProps) => {
  const [field, meta] = useField(name);
  return (
    <FormGroup className="form-group">
      <FormLabel className={`label-wrapper ${toolTipText && 'with-tooltip'}`}>
        {required && <span className="required-indicator">*</span>}
        {labelText}
        {/* //to delete after testing */}
        {/* {toolTipText && (
          <>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-${field.name}`}>{toolTipText}</Tooltip>
              }
            >
              <img
                src={InfoIcon}
                alt="info img"
                className="tooltip-trigger"
                data-toggle="tooltip"
              />
            </OverlayTrigger>
          </>
        )} */}
      </FormLabel>
      {imageFile && OriginalSize ? (
        <img
          height={OriginalHeight}
          width={OriginalWidth}
          src={`data:image/png;base64, ${imageFile}`}
          alt="img"
        />
      ) : null}
      {imageFile && !OriginalSize && !MaintainAspectRatio ? (
        <img
          height={ImageHeight}
          width={ImageWidth}
          src={`data:image/png;base64, ${imageFile}`}
          alt="img"
        />
      ) : null}
      {imageFile && !OriginalSize && MaintainAspectRatio ? (
        <img
          width={ImageWidth}
          src={`data:image/png;base64, ${imageFile}`}
          alt="img"
        />
      ) : null}
      <div className="input-with-postfix">
        <input
          type="number"
          id={field.name}
          className={`form-control ${meta.error && 'is-invalid'}`}
          {...field}
          value={field.value}
          disabled={disabled}
        />
        {meta.error && <p className="error-wrapper">{meta.error}</p>}
        {postfixText && <span className="postfix">{` ${postfixText}`}</span>}
      </div>
    </FormGroup>
  );
};

export { NumberInput };
